export enum AuthGroup {
  ADMIN = 'ADMIN',
  COPS = 'COPS',
  READONLY = 'READONLY',
}

export const authGroupMapping: Record<string, AuthGroup> = {
  admin: AuthGroup.ADMIN,
  cops: AuthGroup.COPS,
  readonly: AuthGroup.READONLY,
}

export interface PiaUser {
  name?: string
  email?: string
  groups: AuthGroup[]
  userLoggedInWithPia?: boolean
}

export interface AuthUtil {
  user?: PiaUser
  isAdmin: boolean
  isCops: boolean
  isReadonly: boolean
  canPerformActions: boolean
  userLoggedInWithPia: boolean
}
